import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Platform } from '@ionic/angular';
import { NavigationStart, Router } from '@angular/router';
import { environment } from '../environments/environment';
import { AnalyticsService } from '../smoothr-web-app-core/services/analytics/analytics.service';
import { Api } from '../smoothr-web-app-core/api/api';
import { NAVIGATIONURLS, NavigationService } from './services/navigation.service';
import { register } from 'swiper/element/bundle';
import { BrazeService } from './services/braze.service';
import { RepositoryService } from 'src/smoothr-web-app-core/services/repository/repository.service';
import { CookieConsentService } from './services/cookie.service';
import { BehaviorSubject, Observable, catchError, filter, of, switchMap } from 'rxjs';
import Order from 'src/smoothr-web-app-core/models/Order';

register();

@Component({
	selector: 'app-root',
	templateUrl: 'app.component.html',
	styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
	static largeScreen = false;
	static analyticsEnabled = false;
	isCookieAccepted = false;
	static isWebApp = true;
	static isNativeApp = false;
	public trackAuthUrl$: Observable<{
		order: boolean;
		auth: boolean;
		home: boolean;
		promo: boolean;
	}>;
	public order$ = new BehaviorSubject<Order | null>(null);

	constructor(
		private router: Router,
		private analytics: AnalyticsService,
		platform: Platform,

		private navigationService: NavigationService,
		private brazeService: BrazeService,
		private cookieService: CookieConsentService,
		public translate: TranslateService,
		private repository: RepositoryService
	) {
		console.log(environment.customerGroup + ' ' + environment.version);
		const favIcon: any = document.querySelector("link[rel*='icon']") || document.createElement('link');
		favIcon.type = 'image/x-icon';
		favIcon.rel = 'shortcut icon';
		favIcon.href = '/assets/icon/reishauer.svg';
		document.getElementsByTagName('head')[0].appendChild(favIcon);
		document.title = translate.instant('index.title.' + environment.customerGroup);

		this.handleCookieConsent();
		const languageValue = localStorage.getItem('langOfApp');
		console.log(languageValue);
		if (languageValue) {
			translate.setDefaultLang(languageValue);
			translate.use(languageValue);
		} else {
			translate.setDefaultLang('de');
			translate.use('de');
		}

		translate.onLangChange.subscribe(languageChanged => {
			if (languageChanged) localStorage.setItem('langOfApp', languageChanged.lang);
		});
		this.repository.obserableOrder.subscribe(order => {
			this.order$.next(order);
		});
		this.trackAuthUrl$ = this.router.events.pipe(
			filter(event => event instanceof NavigationStart),
			switchMap((eventData: NavigationStart) =>
				of({
					auth: eventData?.url?.includes(NAVIGATIONURLS.allInfo()),
					order: eventData?.url?.includes('/' + NAVIGATIONURLS.order()),
					home: eventData?.url?.includes(NAVIGATIONURLS.home()),
					promo: eventData?.url?.includes(NAVIGATIONURLS.promo()),
				})
			),
			catchError(e => {
				return of({
					order: false,
					auth: false,
					home: false,
					promo: false,
				});
			})
		);

		platform.ready().then(() => {
			AppComponent.largeScreen = platform.width() >= 992;
			platform.resize.subscribe(() => {
				AppComponent.largeScreen = platform.width() >= 992;
			});
			console.log(new Date());
			try {
				// Show app immediately (removed 4s delay that was for loading animation)
				console.log('START', document.getElementById('app-root'));
				document.getElementById('app-root').style.opacity = '1';
				document.getElementById('splash-screen')?.remove();
				console.log(new Date());
			} catch (e) {}
		});
		Api.isMaintenanceActive()
			.then(result => {
				if (result) {
					this.navigationService.maintenance();
				}
			})
			.catch(error => {
				console.log(error);
			});
	}
	private disableSdkBraze() {
		this.brazeService.disableSdk();
	}

	ngOnInit() {}

	ngDoCheck() {}

	private handleCookieConsent() {
		try {
			this.cookieService.initializeCookieConsent();
		} catch (e) {}
	}

	async setAnalyticsEnabled(enabled: boolean) {
		await this.analytics.setAnalyticsCollectionEnabled(enabled);
	}

	openPage(value: string) {
		if (!value) {
			return;
		}
		this.router.navigate([value]);
	}
	orderClick() {}
	later() {}
}
